module.exports = __webpack_public_path__ + "media/images/person-277e0a6c47a1f106ee22a41d76f2c52b.jpg";